import TimeAgo from "javascript-time-ago";
import type { UseTranslationResponse } from "react-i18next";

export const initTimeAgo = (translate: UseTranslationResponse<"translation">["t"]) => {
  TimeAgo.addDefaultLocale({
    locale: "en",
    now: {
      now: {
        current: translate("now"),
        future: translate("inAMoment"),
        past: translate("justNow"),
      },
    },
    short: {
      year: "",
      quarter: undefined,
      month: "",
      week: "",
      day: "",
      hour: "",
      minute: "",
      second: "",
    },
    narrow: {
      year: "",
      quarter: undefined,
      month: "",
      week: "",
      day: "",
      hour: "",
      minute: "",
      second: "",
    },
    long: {
      year: {
        future: {
          one: `${translate("in")} {0} ${translate("year")}`,
          other: `${translate("in")} {0} ${translate("years")}`,
        },
        past: {
          one: `{0} ${translate("yearAgo")}`,
          other: `{0} ${translate("yearsAgo")}`,
        },
      },
      quarter: undefined,
      month: {
        future: {
          one: `${translate("in")} {0} ${translate("month")}`,
          other: `${translate("in")} {0} ${translate("months")}`,
        },
        past: {
          one: `{0} ${translate("monthAgo")}`,
          other: `{0} ${translate("monthsAgo")}`,
        },
      },
      week: {
        future: {
          one: `${translate("in")} {0} ${translate("week")}`,
          other: `${translate("in")} {0} ${translate("weeks")}`,
        },
        past: {
          one: `{0} ${translate("weekAgo")}`,
          other: `{0} ${translate("weeksAgo")}`,
        },
      },
      day: {
        future: {
          one: translate("tomorrow"),
          other: `${translate("in")} {0} ${translate("days")}`,
        },
        past: {
          one: translate("yesterday"),
          other: `{0} ${translate("daysAgo")}`,
        },
      },
      hour: {
        future: {
          one: `${translate("in")} {0} ${translate("hour")}`,
          other: `${translate("in")} {0} ${translate("hours")}`,
        },
        past: {
          one: `{0} ${translate("hourAgo")}`,
          other: `{0} ${translate("hoursAgo")}`,
        },
      },
      minute: {
        future: {
          one: `${translate("in")} {0} ${translate("minute")}`,
          other: `${translate("in")} {0} ${translate("minutes")}`,
        },
        past: {
          one: `{0} ${translate("minuteAgo")}`,
          other: `{0} ${translate("minutesAgo")}`,
        },
      },
      second: "",
    },
  });
};
